/* eslint-disable */
import React, { FC, ReactElement } from 'react';
import withBrands from '../../hoc/withBrands';
import withLocalization from '../../hoc/withLocalization';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootReducer';
import isAsia from '../../../util/isAsia';
import './CyberSourceErrorModal.scss';
import { getSafeTelHref } from '../../../util/CommonLogic';

import ParseHtml from '../../common/ParseHtml';
import intlModalCloseLogo from '../../../features/siteTheme/Brands/tmvcs/logo/intlModalCloseLogo.svg';
import intlCloseLogoHover from '../../../features/siteTheme/Brands/tmvcs/logo/intlCloseLogoHover.svg';
import phoneLogo from '../../../features/siteTheme/Brands/tmvcs/logo/intl-phoneLogo.svg';
interface ImgModalProps {
  localize?: any;
  image?: string;
  closeModal: () => void;
  msg?: string;
  phoneNo?: any;
  localizeImages?: any;
  prospectDetails?: any;
}

const CyberSourceErrorModal: FC<any> = (props: ImgModalProps): ReactElement => {
  const { closeModal, localize, localizeImages, phoneNo, prospectDetails } = props;
  const modalErrStatus = useSelector((state: RootState) => state.newOfferPaymentDetails.paymentModalErrStatus);
  const defaultPhNo = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-phone-number')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-phone-number');
  const defaultChatLinkText = isAsia
    ? localize('preview-sales-engine.static-content.copy.pbeo.intl.asia-default-chat-link')
    : localize('preview-sales-engine.static-content.copy.pbeo.intl.me-default-chat-link');
  const whatsAppImgData = localizeImages('preview-sales-engine.static-content.images.whatsapp-logo', 0, '5:1');
  const whatsAppPath = whatsAppImgData?.path || '';
  const callCenterCode = prospectDetails?.callCenterCode || '';
  const jahiaCallcenter = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.errorPhone`;
  const callCenterDefault = `${localize(jahiaCallcenter)}`;
  //const phoneWithDialcode = phoneNo || callCenterDefault;
  const phoneWithDialcode = callCenterDefault;
  const defaultErrorPhone = phoneWithDialcode || defaultPhNo;
  const jahiaKey = `preview-sales-engine.static-content.copy.pbeo.intl.call-centers.${callCenterCode}.chat-link`;
  const chatLinkText: any = localize(jahiaKey) || defaultChatLinkText;
  const handleKeyDown = () => {};
  const cardErrorMsg = localize(
    `preview-sales-engine.static-content.copy.Labels.error-message.pbeo.intl-auth-token-error-description`,
  );
  const handleClickChatLink = (e: any) => {
    e.preventDefault();
    //window.location.href = chatLinkText;
    window.open(chatLinkText, '_blank');
    window.dataLayer.push({
      event: 'whatsapp',
    });
  };

  return (
    <div className="modal-cyberSource-err">
      <div className="modal-content-cyberSourceErr">
        <div className="cyberSourceErr-container">
          <div className="cyberSource-err-head-container">
            <div className="cyberSourceErrModal-title-container">
              <span className="cyberSourceErr-title-text">
                {localize(`preview-sales-engine.static-content.copy.Labels.error-message.pbeo.auth-token-error-title`)}
              </span>
            </div>
            <div className="cyberSource-err-close-icon-wrapper">
              <button
                className="cyberSourceErr-modal-close-btn"
                // src={intlModalCloseLogo}
                // type="image"
                onClick={closeModal}
                aria-label="close"
              >
                <img src={intlModalCloseLogo} alt="close" className="close-icon" />
              </button>
            </div>
          </div>

          <div className="cyberSourceErr-content-section">
            <div className="cyberSourceErr-desc-container">
              <div className="cyberSourceErr-desc-text">
                <ParseHtml htmlInput={cardErrorMsg} />
              </div>
              <div className="payment-err-phone-container">
                <div className="payment-err-phone-link">
                  <a className="err-phone-anchor" href={encodeURI(getSafeTelHref(defaultErrorPhone))}>
                    <img
                      onKeyDown={handleKeyDown}
                      tabIndex={0}
                      src={phoneLogo}
                      alt="Call Now"
                      className="cybersource-payment-err-phone-icon"
                    />
                    <span
                      aria-label={'phone-err-call'}
                      onKeyDown={handleKeyDown}
                      tabIndex={0}
                      className="cybersource-payment-err-phone"
                    >{`+${defaultErrorPhone}`}</span>
                  </a>
                  {chatLinkText && (
                    <>
                      <div className="header-pipe">|</div>
                      <a href={'#'} onClick={handleClickChatLink}>
                        <img className="err-paymentphone-img" src={whatsAppPath} alt="whatsapp" />
                      </a>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="cyberSourceModalErr-section">
            <div
              className="cyberSourceErr-close-wrapper"
              onClick={closeModal}
              arial-label={'see-detail'}
              role="button"
              tabIndex={0}
              onKeyDown={handleKeyDown}
            >
              <div className="cyberSourceErr-close-text-span">
                {localize(`preview-sales-engine.static-content.copy.pbeo.ineligible-state-thank-you-modal-cta`)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default React.memo(withLocalization(withBrands(CyberSourceErrorModal)));
